import { useUserContext } from 'common/contexts/UserContext';
import { Calendars, CalendarSchedule } from 'components/CalendarSchedule';
import * as React from 'react';
import LaptopWithCallouts from 'assets/images/laptop-with-callouts.png';
import { useLogout } from 'ducks/user';
import { SignupStatus } from 'constants/user';
import { Navigate } from 'react-router-dom';
import { Routes } from 'constants/pages';
import fonts from 'styles/typography.module.css';

// Refetch the user every 10 seconds
const REFETCH_TIMEOUT = 1000 * 10;

export const Waitlist: React.FC = () => {
  const { user, fetchUser } = useUserContext();
  const logout = useLogout();

  // Continue to fetch user until they are approved
  React.useEffect(() => {
    const id = window.setInterval(fetchUser, REFETCH_TIMEOUT);
    return () => window.clearInterval(id);
  }, [fetchUser]);

  if (user?.signup_status === SignupStatus.Complete) {
    return <Navigate to={Routes.Landing} replace />;
  }

  return (
    <div className={`flex flex-col md:flex-row h-full ${fonts.font}`}>
      <div className="bg-gray-800 w-full md:w-1/2 lg:w-7/12 order-last md:order-first">
        <div className="p-9 pt-20">
          <div className="space-y-3">
            <p className="text-gray-400 font-medium">
              Hi{user?.first_name ? ` ${user.first_name},` : ','} start shedding light on the
              terminal blackbox! You&apos;re #53 on the waitlist.
            </p>
            <h1 className="font-bold text-gray-100 pb-4">
              Congratulations, you&apos;re on our waitlist!
            </h1>
            <p className="text-gray-300">
              We have released the first nationwide container management system to monitor and
              mitigate accessorial fees - we are receiving a high influx of demand and look forward
              to welcoming you. Someone will reach out to you ASAP to help you get your account
              fully set up.
            </p>
            <h4
              className="underline text-gray-500 hover:text-gray-400 transition cursor-pointer inline-block"
              onClick={logout}
            >
              Log out
            </h4>
          </div>
          <div className="w-full flex justify-center mt-32">
            <img src={LaptopWithCallouts} alt="Laptop with callouts" />
          </div>
        </div>
      </div>
      <div className="bg-gray-100 h-screen w-full md:w-1/2 lg:w-5/12 order-first md:order-last">
        <div className="h-full flex flex-col items-center pb-20 pt-32 gap-6">
          <h1 className="font-bold text-3xl">Schedule a demo!</h1>
          <div className="drop-shadow-xl h-full w-9/12">
            <CalendarSchedule url={Calendars.ScheduleDemo} />
          </div>
        </div>
      </div>
    </div>
  );
};
